import { CustomElement } from '@aurelia/runtime-html';
export const name = "team-game-read-only";
export const template = "<template>\n  <span class=\"team\" mouseover.trigger=\"mouseOver(true)\"  mouseleave.trigger=\"mouseLeave(true)\" >${homeTeam}</span> -\n  <span class=\"team\" mouseover.trigger=\"mouseOver(false)\"  mouseleave.trigger=\"mouseLeave(false)\" >${opponentTeam}</span>\n</template>\n";
export default template;
export const dependencies = [  ];
export const bindables = {};
let _e;
export function register(container) {
  if (!_e) {
    _e = CustomElement.define({ name, template, dependencies, bindables });
  }
  container.register(_e);
}
